module.exports = __webpack_public_path__ + "static/media/2020 - Harley-Davidson Connect.29b38401.pdf";